// API configuration for different environments

const config = {
  development: {
    leetcode: {
      baseUrl: '/api/leetcode',
      useProxy: true,
      fallbackProxy: null
    }
  },
  production: {
    leetcode: {
      baseUrl: 'https://leetcode.com',
      useProxy: false,
      // Use a more reliable CORS proxy for production
      fallbackProxy: 'https://api.allorigins.win/raw?url=https://leetcode.com'
    }
  }
};

// Get current environment
const currentEnv = process.env.NODE_ENV || 'development';

// Export current config
export const apiConfig = config[currentEnv];

// Helper function to get LeetCode URL
export const getLeetCodeUrl = (endpoint = '') => {
  const baseUrl = apiConfig.leetcode.baseUrl;
  return endpoint ? `${baseUrl}/${endpoint}` : baseUrl;
};

// Helper function to check if we should use proxy
export const shouldUseProxy = () => {
  return apiConfig.leetcode.useProxy;
};

// Helper function to get fallback proxy
export const getFallbackProxy = () => {
  return apiConfig.leetcode.fallbackProxy;
};

export default apiConfig;
